import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthConnectProvider } from '../providers/account/auth-connect';
import { IOtherSetting } from '../models/service/other-settings.model';
import { EnvironmentData } from '../../environments/environment-data';
import { IDeliveryExceptions } from '../models/service/checkpoints-settings.model';
import { IAllSettings } from '@models/service/all-settings.model';

@Injectable({
  providedIn: 'root',
})
export class UtilitiesService {
  constructor(private http: HttpClient) { }

  private get TLUrl() {
    return EnvironmentData.getTLUrl();
  }

  private get settings() {
    return AuthConnectProvider.getSettings();
  }

  /**
   * /settings/others/<organization id>
   * Get Tray Logistics Other Settings for the specific facility .
   */
  getOtherSettings(): Promise<IOtherSetting[]> {
    const request = this.http
      .get<IOtherSetting[]>(
        `${this.TLUrl}/settings/${this.settings?.organizationId}/others`,
      )
      .toPromise();
    return request;
  }

  getFacility(): Promise<any> {
    return this.http.get<any[]>(`${this.TLUrl}/facility/${this.settings?.organizationId}`)
      .toPromise();
  }

  getMiddlewareVersion(): Promise<any> {
    return this.http.get<any[]>(`${this.TLUrl}/version`).toPromise();
  }

  public getExceptionList(): Promise<IDeliveryExceptions> {
    return this.http.get<IDeliveryExceptions>(
      `${this.TLUrl}/settings/${this.settings?.organizationId}/deliveryExceptions`,
    )
      .toPromise();
  }

  public logoutAudited(organizationId: string): Promise<any> {
    const url = `${this.TLUrl}/userPrivileges/${organizationId}/logout`;
    const request = this.http.post<any>(url, {}).toPromise();
    return request;
  }

  public getAllSettings(): Promise<IAllSettings> {
    const request = this.http.get<IAllSettings>(`${this.TLUrl}/settings/${this.settings?.organizationId}`).toPromise();
    return request;
  }
}
